import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=05035c7b&scoped=true"
import script from "./DataDictionary.vue?vue&type=script&lang=js"
export * from "./DataDictionary.vue?vue&type=script&lang=js"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=05035c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05035c7b",
  null
  
)

export default component.exports